import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/ContactHero.css";
import contactImg from "../assets/contact-tanbio.jpeg";

/* ─── Feature Badge ──────────────────────────────── */
const FeatureBadge = ({ icon, title, sub }) => (
  <div className="ch-feature-badge">
    <div className="ch-feature-icon">
      <i className={icon}></i>
    </div>
    <div>
      <div className="ch-feature-title">{title}</div>
      <div className="ch-feature-sub">{sub}</div>
    </div>
  </div>
);

/* ─── ContactHero ────────────────────────────────── */
const ContactHero = () => {
  return (
    <section className="ch-section">

      {/* ── Background pattern layer ── */}
      {/* handled via CSS background-image on .ch-section */}

      {/* ── White overlay (left-side fade) ── */}
      <div className="ch-overlay" aria-hidden="true" />

      {/* ── Right curved panel ── */}
      <div className="ch-right-bg" aria-hidden="true">
        {/* Blue curved border accent */}
        <span className="ch-right-border-accent" />

        {/* Contact building image */}
        <div className="ch-image-wrapper">
          <img
            src={contactImg}
            alt="TANBIO Biomed Genomics Laboratory building"
            loading="lazy"
            className="ch-right-img"
          />
        </div>
      </div>

      {/* ── Left content ── */}
      <Container className="ch-container">
        <Row className="ch-inner align-items-center">
          <Col xs={12} lg={6} className="ch-left-col">

            <div className="ch-anim-wrap">

              {/* eyebrow */}
              <p className="ch-eyebrow">CONTACT US</p>

              {/* heading */}
              <h1 className="ch-heading">
                We Are Here<br />
                To{" "}
                <span className="ch-heading-highlight">Help You</span>
              </h1>
              
              {/* <h1 className="ch-heading">
                WE ARE HERE
                TO{" "}
                <span className="ch-heading-highlight">HELP YOU</span>
              </h1> */}

              {/* description */}
              <p className="ch-desc">
                Have questions or need assistance?<br />
                Reach out to us. We're here to provide you with<br />
                the best diagnostic experience.
              </p>

              {/* feature badges */}
              <div className="ch-features">
                <FeatureBadge
                  icon="fa-solid fa-headset"
                  title="Quick Support"
                  sub="We are always ready to assist you"
                />
                <FeatureBadge
                  icon="fa-solid fa-shield-halved"
                  title="Trusted Care"
                  sub="Accurate tests with reliable results"
                />
              </div>

            </div>

          </Col>
        </Row>
      </Container>

    </section>
  );
};

export default ContactHero;
